import React from 'react';
import { Routes, Route } from 'app/src/utils/routing';

import { View, Text } from 'react-native';

import Home from 'app/src/components/Home';

import Clients from 'app/src/components/Clients';
import NewClient from 'app/src/components/Clients/new';
import ClientContainer from 'app/src/components/Clients/Container';
import Client from 'app/src/components/Clients/show';

import Events from 'app/src/components/Events';
import NewEvent from 'app/src/components/Events/new';
import Event from 'app/src/components/Events/show';

import EventTypes from 'app/src/components/EventTypes';
import NewEventType from 'app/src/components/EventTypes/new';
import EventType from 'app/src/components/EventTypes/show';

import Libraries from 'app/src/components/Libraries';
import NewLibrary from 'app/src/components/Libraries/new';
import Library from 'app/src/components/Libraries/show';

import Things from 'app/src/components/Things';
import NewThing from 'app/src/components/Things/new';
import Thing from 'app/src/components/Things/show';

import Users from 'app/src/components/Users';

const PrimaryRoutes = () => {
  return (
    <Routes>
      <Route index element={<Home />} />

      <Route path="/clients">
        <Route index element={<Clients />} />
        <Route path="new" element={<NewClient />} />

        <Route path=":clientId" element={<ClientContainer />}>
          <Route index element={<Client />} />

          <Route path="events" element={<ClientContainer />}>
            <Route index element={<Events />} />
            <Route path="new" element={<NewEvent />} />
            <Route path=":id" element={<Event />} />
          </Route>
        </Route>
      </Route>

      <Route path="/events">
        <Route index element={<Events />} />
        <Route path="new" element={<NewEvent />} />
        <Route path=":id" element={<Event />} />
      </Route>

      <Route path="/event-types">
        <Route index element={<EventTypes />} />
        <Route path="new" element={<NewEventType />} />
        <Route path=":id" element={<EventType />} />
      </Route>

      <Route path="/libraries">
        <Route index element={<Libraries />} />
        <Route path="new" element={<NewLibrary />} />
        <Route path=":id" element={<Library />} />
      </Route>

      <Route path="/things">
        <Route index element={<Things />} />
        <Route path="new" element={<NewThing />} />
        <Route path=":id" element={<Thing />} />
      </Route>

      <Route path="/users" element={<Users />} />
    </Routes>
  );
};

export default PrimaryRoutes;
